import { createSelector } from '@ngrx/store';
import { softBanFeature } from 'src/app/core/state/slices/soft-ban/soft-ban.reducer';

// Just omitting name and reducer only to keep selectors for cleanliness.
const { name, reducer, ...softBanFeatureSelectors } = softBanFeature;

/**
 * Selectors are used to implement business logic that otherwise
 * would be implemented on the page level.
 *
 * Selectors are memorized functions meaning that the last result
 * would be returned without recalculation if underlying data remains unchanged.
 */
const selectCanInitialise = createSelector(
  softBanFeature.selectSoftBanFeatureState,
  (state) => !state.loaded && !state.loading,
);

const selectCanShowModal = (route: string) =>
  createSelector(softBanFeature.selectSoftBanFeatureState, (state) => !state.modalShownRoutes.includes(route));

export const SoftBanSelectors = {
  // Automatically destructure selectors available from feature reducer
  ...softBanFeatureSelectors,
  selectCanInitialise,
  selectCanShowModal,
};
